import { GenericComponent } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { useStyles } from '../../../hooks/useStyles';

export function StyledCardBodyWrapper({
  children,
  classNames = '',
  height = 'auto',
}: GenericComponent & { height?: string }) {
  const { css, concatenateClasses, theme } = useStyles();

  const baseStyles = css({
    padding: theme.sizing.scale600,
    height: height,
  });

  return <Block className={concatenateClasses(baseStyles, classNames)}>{children}</Block>;
}
